import styled from "styled-components";

export const EmptyCabinet = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 32px;
  font-size: 15px;
  line-height: 140%;
  color: #A1ABC9;
  flex-grow: 1;
  padding-top: 20px;
  margin-bottom: 32px;

  & img {
    padding-bottom: 32px;
  }
`